
import Stmnavbar from "@/components/stm-nav-bar.vue";
import Footer from "@/components/footer-component.vue";
import Mobile from "@/components/mobile-header.vue";

export default {
  components: { Stmnavbar, Footer, Mobile },
};
